import { Trans, useTranslation } from "react-i18next";
import { CookieConsentProps } from "../../types/CookieConsentProps";
import CookieConsentStyles from "./CookieConsent.module.css";

export const CookieConsent = ({
    onAcceptAll,
    onRejectAll,
    onClickCookiePolicy
}: CookieConsentProps) => {
    const { t } = useTranslation("common");

    const cookieConsentDescription = () => (
        <Trans
            i18nKey={"cookieConsent.description"}
            t={t}
            components={[
                <a
                    className={CookieConsentStyles['cookie-policy-link']}
                    key="cookie-policy-link"
                    onClick={onClickCookiePolicy}
                    target="_blank"
                />
            ]}
        />
    );
    
    return (
        <div
            className={CookieConsentStyles['container']}
        >
            <div
                className={CookieConsentStyles['cookie-dialog-container']}
            >
                <div className={CookieConsentStyles['cookie-dialog-header']}>
                    <div 
                        className={CookieConsentStyles['cookie-dialog-header-text']}
                    >
                        {`${t("cookieConsent.title")}`}
                    </div>
                </div>
                <div className={CookieConsentStyles['cookie-dialog-content-container']}>
                    <p className={CookieConsentStyles['cookie-dialog-text']}>
                        {cookieConsentDescription()}
                    </p>
                    <div className={CookieConsentStyles['cookie-dialog__button-container']}>
                        <button
                            className={CookieConsentStyles['cookie-dialog-button']}
                            onClick={onRejectAll}
                        >
                            <span>
                                {`${t("cookieConsent.reject")}`}
                            </span>
                        </button>
                        <button
                            className={CookieConsentStyles['cookie-dialog-button']} 
                            onClick={onAcceptAll}
                        >
                            <span className="cookie-dialog_button-text">
                                {`${t("cookieConsent.accept")}`}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};
